import { io } from "socket.io-client";

export const APP_UPDATE_AVAILABLE = 'app update available';
export const USER_MESSAGE_AVAILABLE = 'user message available';

export const ORDER_REQUEST_ASSIGNED = 'order request assigned';
export const DEDICATION_TO_USER = "dedication as user";


const serverEndpoint: string = process.env.REACT_APP_SERVER_ENDPOINT as string;
const socket = io(serverEndpoint, {
    autoConnect: false
});

socket.connect();

export default socket;